// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import jquery from 'jquery'
import moment from 'moment'
import accounting from 'accounting'
import router from './router'
import Cookie from 'vue-cookie'
import Resource from 'vue-resource'
import Bootstrap from 'bootstrap'
import VTooltip from 'v-tooltip'
import VueChatScroll from 'vue-chat-scroll'
import VueBreadcrumbs from 'vue-breadcrumbs'
import swal from 'sweetalert'
import { Popover } from 'bootstrap-vue/es/components';
import Paginate from 'vuejs-paginate'
import Notifications from 'vue-notification'

Vue.use(Notifications)
Vue.use(Popover);
Vue.component('paginate',Paginate);

import oauth from '@/mixins/oauth2'
Vue.mixin(oauth);

import fieldCompetitor from "@/components/form/fieldCompetitor.vue"
import fieldDatetime from "@/components/form/fieldDatetime.vue"
import fieldTelephone from "@/components/form/fieldTelephone.vue"
import fieldUser from "@/components/form/fieldUser.vue"
import fieldGame from "@/components/form/fieldGame.vue"
import fieldAmountRange from "@/components/form/fieldAmountRange.vue"
import fieldChoices from "@/components/form/fieldChoices.vue"
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import FlagIcon from 'vue-flag-icon'
import VueTabs from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css'
import VueLocalForage from 'vue-localforage'
import BootstrapVue from 'bootstrap-vue'
import { Collapse } from 'bootstrap-vue/es/components';
import VueWaypoint from 'vue-waypoint'
Vue.use(VueWaypoint);

import paginate from 'vuejs-paginate';

//import VueAwesomeSwiper from 'vue-awesome-swiper'
//import 'swiper/dist/css/swiper.css'
//Vue.use(VueAwesomeSwiper)

Vue.use(Collapse);

import Chart from 'chart.js'
import 'choices.js/assets/styles/css/choices.min.css';

Vue.use(VueTabs)

import { Dropdown } from 'bootstrap-vue/es/components';

Vue.use(Dropdown);

import { Layout } from 'bootstrap-vue/es/components';

Vue.use(Layout);

import { Button } from 'bootstrap-vue/es/components';

Vue.use(Button);

import { Form } from 'bootstrap-vue/es/components';

Vue.use(Form);

import { FormInput } from 'bootstrap-vue/es/components';

Vue.use(FormInput);

import { FormGroup } from 'bootstrap-vue/es/components';

Vue.use(FormGroup);

import { InputGroup } from 'bootstrap-vue/es/components';

Vue.use(InputGroup);

import 'fullpage.js/dist/fullpage.css'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
// import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'

Vue.use(VueFullPage);

import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.min.css';

import VueJsonPretty from 'vue-json-pretty'

// Init plugin
Vue.use(Loading);
Vue.component('paginate', paginate)
Vue.component('loading', Loading)
Vue.component('VueJsonPretty', VueJsonPretty)

Vue.component('SweetModal', SweetModal)
Vue.component('SweetModalTab', SweetModalTab)
Vue.use(SweetModal)
Vue.use(SweetModalTab)
Vue.use(VueLocalForage)

Vue.component("fieldCompetitor", fieldCompetitor);
Vue.component("fieldDatepicker", fieldDatetime);
Vue.component("fieldTelephone", fieldTelephone);
Vue.component("fieldUser", fieldUser);
Vue.component("fieldGame", fieldGame);
Vue.component("fieldAmountRange", fieldAmountRange);
Vue.component("fieldChoices", fieldChoices);

import bTab from 'bootstrap-vue/es/components/tabs/tab';
import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
import cLoader from '@/components/ui/loader/cloader'

Vue.component('b-tab', bTab);
Vue.component('b-tabs', bTabs);
Vue.component('cloader', cLoader);

Vue.use(VueChatScroll)
Vue.use(VTooltip)
Vue.directive('tooltip', VTooltip.VTooltip)

window.api = '';
window.wsapi = 'wss://ws.feedera.xyz/';
window.bsapi = location.protocol+'//feedera.xyz/';
window.session = new Object;
window.loading = 0;

if (window.location.hostname == 'localhost') {
  location.protocol = 'http:';
  window.wsapi = 'ws://bs.co';
  window.bsapi = 'http://bs.co/';
  //window.bsapi = 'https://fs.plysport.com/';
}

window.auth = new Object;

window.accessTokenHeader = null;
Vue.use(FlagIcon);
Vue.use(Resource)
Vue.use(Cookie)
Vue.config.productionTip = false
Vue.http.options.emulateJSON = true;

Vue.use(VueBreadcrumbs, {
    template: '<ul class="breadcrumb" v-if="$breadcrumbs.length"> ' +
    '<li class="breadcrumb-item"><router-link :to="{ name: \'home\' }">{{ $root.t.navigation[\'home\'] }}</router-link></li>' +
    '<li class="breadcrumb-item" v-for="(crumb, key) in $breadcrumbs"><span v-if="$route.meta.breadcrumb == crumb.name">{{ $root.t.navigation[crumb.name.toLowerCase()] }}</span><router-link :to="linkProp(crumb)" :key="key" v-if="$route.meta.breadcrumb != crumb.name">{{ $root.t.navigation[crumb.name.toLowerCase()] }}</router-link></li> ' +
    '</ul>'
});

Vue.http.options.emulateJSON = true;

Vue.http.interceptors.push((request, next) => {

  request.timeout = 0;

function getCookie(name) {
  function escape(s) { return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1'); };
  var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
  return match ? match[1] : null;
}

if( !request.url.match('api/v1/get/client') && typeof window.auth.accessToken !== 'undefined' ) {

    /*
    if (!request.params.access_token) {
        if (!request.url.match('access_token=')) {
            if (request.params != 0) {

                request.params.access_token = window.auth.accessToken;
            }
        }
    } */
  request.headers.set('Authorization', 'Bearer '+window.auth.accessToken);
}
request.headers.set('Accept-Language', window.locale);

//console.log(request);
next()
})

const EventBus = new Vue()

Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus
        }
    }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
    data: {
        moment: moment
    },
  template: '<App />',
  components: { App }
})

var mixin = {
    methods: {
        findByKeyAndRemove (source, key, id) {
            if (source) {
                for (var i = 0; i < source.length; i++) {
                    if (source[i][key] === id) {
                        source.splice(key, 1);
                    }
                }
                return false;
            }else {
                return false;
            }

        },
        findByKeyAndReplace (source, key, id, data) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === id) {
                    source[i] = data;
                }
            }
            return false;
        },
        findByKey (source, key, find) {
            if (source) {
                for (var i = 0; i < source.length; i++) {
                    if (source[i][key] == find) {
                        return source[i];
                    }
                }
                return false;
            }else {
                return false;
            }
        },
        uformat (str, args) {

            $.each(args, function(key, value) {
                str = str.replace(new RegExp("\\%" + key + "\\%", "gi"), value);
            });

            return str;
        },
        phpToMoment(str) {
            let replacements = {
                'd' : 'DD',
                'D' : 'ddd',
                'j' : 'D',
                'l' : 'dddd',
                'N' : 'E',
                'S' : 'o',
                'w' : 'e',
                'z' : 'DDD',
                'W' : 'W',
                'F' : 'MMMM',
                'm' : 'MM',
                'M' : 'MMM',
                'n' : 'M',
                't' : '', // no equivalent
                'L' : '', // no equivalent
                'o' : 'YYYY',
                'Y' : 'YYYY',
                'y' : 'YY',
                'a' : 'a',
                'A' : 'A',
                'B' : '', // no equivalent
                'g' : 'h',
                'G' : 'H',
                'h' : 'hh',
                'H' : 'HH',
                'i' : 'mm',
                's' : 'ss',
                'u' : 'SSS',
                'e' : 'zz', // deprecated since Moment.js 1.6.0
                'I' : '', // no equivalent
                'O' : '', // no equivalent
                'P' : '', // no equivalent
                'T' : '', // no equivalent
                'Z' : '', // no equivalent
                'c' : '', // no equivalent
                'r' : '', // no equivalent
                'U' : 'X'
            };

            return str.split('').map(chr => chr in replacements ? replacements[chr] : chr).join('');
        },
        dateTimeFormat (date) {
            console.log(window.session.date_time_format)
            var stillUtc = window.moment.utc(date).toDate();
            var local = window.moment(stillUtc).local().format(this.phpToMoment(window.session.date_time_format));

            return local
        },
        _df (date) {
            return window.moment(date).format(this.phpToMoment(window.session.date_format), { trim: false })
        },
        dateNow () {
            var myDate = new Date();
            var myDate_string = myDate.toISOString();
            var myDate_string = myDate_string.replace("T"," ");
            var myDate_string = myDate_string.substring(0, myDate_string.length - 5);
            return myDate_string;
        },
        sortByKey(array, key) {
            return array.sort(function(a, b) {
                var x = a[key]; var y = b[key];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        },
        sortAByKey(array, key) {
          var array = Object.values(array);
          return array.sort(function(a, b) {
            var x = a[key]; var y = b[key];
            return ((x > y) ? 1 : ((x < y) ? -1 : 0));
          });
        },
        moment(date) {
            return window.moment(date);
        },
        controlPanel () {
            if (this.$root.panelActive) {
                this.$root.panelActive = false;
            }else {
                this.$root.panelActive = true;
            }

            this.$bus.$emit('openPanel',this.$root.panelActive);
        },
        periodTimer (m) {

            if(m.periodTimeLeft != 0){

                return m.periodTimeLeft;

            }else if(m.periodTime > 0){
                const min = (m.periodTime / 60).toFixed(0);

                return (min > 0) ? min+"'" : '';
            }

            if(m.periodCounter > 0){
                const min = (m.roundCounter / 3600).toFixed(2);

                return (min > 0) ? min+"'" : '';
            }
        },
        timer (date) {
            // Set the date we're counting down to
            var countDownDate = new Date(date).getTime();


            // Get todays date and time
            var now = new Date().getTime();

            // Find the distance between now an the count down date
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Display the result in the element with id="demo"

            return moment(date).fromNow(true);
        },
    },
    filters: {
        uformat: function (str, args) {

            args.forEach(myFunction)

            for (var a in args) {
                str = str.replace(new RegExp("\\%" + a.key + "\\%", "gi"), a);
            }


            return unescape(str);
        },
        toMoney: function (val,currency,symbol = true) {

            if (!currency)
                return false;

            let formatConfig = "%s %v"


            if (currency.position === 'before'){
                formatConfig = "%s %v";
            } else {
                formatConfig = "%v %s";
            }

            var mony = accounting.formatMoney(val, {
                format:  formatConfig,
                symbol: currency.symbol,
                precision : 2,
                thousand : ',',
                decimal : '.',
            });

            if(currency.position == 'before'){
                if(symbol) {
                    return mony;
                }else {
                    return currency.iso_code+' '+mony;
                }
            }else {
                if(symbol) {
                    return mony;
                }else {
                    return mony+' '+currency.iso_code;
                }
            }
        },
        moment: function (date,format,tz) {
            if(date){
                return (format && tz) ? window.moment(date).format(format, { trim: false }) : date;
            }
        },
        tz: function (dt,tz,format,ago = true) {
            window.moment.tz.add(tz)
            if(ago){
                return (dt && tz) ? window.moment(dt).fromNow() : '--'; // 5 years ago
            }else {
                return (dt && tz) ? window.moment(dt).format(format, { trim: false }) : '--'; // 5 years ago
            }
        },
        timeAgo: function (dt) {
            //window.moment.tz.add(window.session.date_time_format);
            return (dt) ? window.moment(dt).fromNow() : '';
        },
        slimiter: function(str, limit) {
            return (str.length > limit) ? str.substring(0,limit)+'...' : str;
        },
        nPlus: function (number) {
            return (number > 90) ? '90+' : number;
        },
        arrayFragmentation: function (Array, n = 6) {
            var count = Array.length;
            var newArray = new Array();

            for(i = 0; i <= count;) {
                newArray[i] = Array.slice(i, n);
                i++;
            }
        },

    }
}

Vue.mixin(mixin);


Array.prototype.contains = function(obj) {
  var i = this.length;
  while (i--) {
    if (this[i] == obj) {
      return true;
    }
  }
  return false;
}




// WEBPACK FOOTER //
// ./src/main.js